import { priceRequester as request } from './requesters';
import { CatalogPriceZoneParams } from 'features/products/hooks/useCatalogPrices';
import { ProductTarifType } from 'shared/constants/business.constants';
import {
  CatalogPriceZoneOneServiceProvider,
  CatalogPriceZoneResponse,
  CatalogPriceZoneServiceProvider,
  CatalogPriceZoneServiceProviderRequest,
  ManualProductPrices,
  QueryParams,
} from 'shared/types';
import { CatalogPrice } from '../models';

const catalogPriceService = {
  getCatalogPrices: (query: QueryParams) =>
    request.get<CatalogPrice[]>(`/catalog-prices`, {
      params: query,
    }),
  createCatalogPrice: (data: CatalogPrice) => request.post<CatalogPrice>(`/catalog-prices`, data),
  getCatalogPriceZoneServiceProviders: (data: CatalogPriceZoneServiceProviderRequest) =>
    request.post<{
      products: { id: number; type: ProductTarifType }[];
      serviceProviderCatalogPriceWithPrice: CatalogPriceZoneServiceProvider[];
      manualProductPrices: ManualProductPrices[];
    }>(`/catalog-prices-zone-service-provider`, data),
  getOneCatalogPriceZoneServiceProvider: (data: CatalogPriceZoneServiceProviderRequest) =>
    request.post<{
      product: { productId: number };
      serviceProviderCatalogPriceWithPrice: CatalogPriceZoneOneServiceProvider;
      manualProductPrices: ManualProductPrices[];
    }>(`/catalog-prices-zone-service-one-provider`, data),
  getCatalogPriceZones: (data: CatalogPriceZoneParams) =>
    request.post<CatalogPriceZoneResponse>(`/catalog-prices-zone`, data),
};

export default catalogPriceService;
